  import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
} from '@angular/core';

@Component({
  selector: 'vtab-action-bar',
  templateUrl: './vtab-action-bar.component.html',
  styleUrls: ['./vtab-action-bar.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VTabActionBarComponent implements AfterContentInit {
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _elementRef = inject(ElementRef);

  /**
   * Whether the action bar contains only button components
   */
  hasOnlyButtons = false;

  /**
   * The number of button components in the action bar
   */
  buttonCount = 0;

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.checkContentType();
    }, 3000)
  }

  private checkContentType(): void {
    const contentElement = this._elementRef.nativeElement.querySelector(
      '.vtab-action-bar-content'
    );

    if (contentElement) {
      const children = Array.from(contentElement.children) as Element[];

      const buttonSelectors = [
        'cipx-cancel-button',
        'cipx-primary-button',
        'cipx-button',
      ];
      const buttons = children.filter((child) =>
        buttonSelectors.some(
          (selector) => child.tagName.toLowerCase() === selector
        )
      );

      this.buttonCount = buttons.length;
      this.hasOnlyButtons =
        children.length > 0 && children.length === this.buttonCount;

      // console.log('Action bar content type:', this.hasOnlyButtons ? 'buttons only' : 'mixed content', 'count:', this.buttonCount)
      this._changeDetectorRef.markForCheck();
    }
  }
}
